import { render, staticRenderFns } from "./RoleRestrictionsPerTag.vue?vue&type=template&id=04bd7612"
import script from "./RoleRestrictionsPerTag.vue?vue&type=script&lang=js"
export * from "./RoleRestrictionsPerTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports